
const initialState = {
    actions: [],
    history: []
};

export const history = (state = initialState, action) => {

    if(action.type === "HISTORY_ACTION"){
        // alert("HISTORY_ACTION: " + action.action+": " + action.location.pathname);
        let newHistory = Object.assign({},state);
        newHistory.actions.push({action:action.action, location: action.location})
        if(action.action === "PUSH"){
            let lastPath = newHistory.history.pop();
            if(lastPath != action.location.pathname){
                newHistory.history.push(lastPath);
            }
            newHistory.history.push(action.location.pathname)
        }else if(action.action === "POP"){
            let found = false;
            for(let i=0;i<newHistory.history.length;i++){
                if(newHistory.history[i] === action.location.pathname){
                    found=true
                    if(i < (newHistory.history.length -1)){
                        newHistory.history = newHistory.history.slice(0,i+1);
                    }
                }
            }
            if(!found){
               newHistory.history = [];
                newHistory.history.push(action.location.pathname);
            }
        }else if(action.action === "GO"){
            newHistory.history  = newHistory.history.slice(0, newHistory.history.length - action.count);
        }
        return newHistory;
    }else{
        return state;
    }
}



// WEBPACK FOOTER //
// ./src/common/reducers/history-reducer.js